// Package Imports

import { BrowserRouter as Router, Routes, Route } from "react-router-dom"
import { ThemeProvider } from "@mui/material"
import { ToastContainer } from "react-toastify"

// Style Imports

import "react-toastify/dist/ReactToastify.css"
import { theme } from "./Atom"

// Component Imports

import Layout from "../components/Layout"
import ProtectedRoute from "../components/ProtectedRoute"

// Configuration Imports

import { permissions } from "../../config/constants"

// Used Page Imports
import {
  AuthPage,
  MyProfile,
  Huddle,
  Dashboard,
  UserManagement,
  CustomerManagement,
  GroupProfile,
  MetricBlueprint,
  MetricGoal,
  MetricOpportunity,
  OpportunityDashboard,
  ResourceBudget,
  PNLBudget,
  PnlReporting,
  Providers,
  UserProfile,
  DoctorCompensation,
  ProntoAi,
} from "../pages"

// Unused Page Imports

import {
  Audit,
  Compliance,
  ProviderProductionSummary,
  HelpCenter,
  OfficeHours,
} from "../pages"

const AppRoutes = () => {
  return (
    <ThemeProvider theme={theme}>
      <Router>
        <Routes>
          {/* Authorized Routes */}

          <Route
            path="/users"
            element={
              <Layout>
                <ProtectedRoute permission={permissions?.VIEW_USER_MANAGEMENT}>
                  <UserManagement />
                </ProtectedRoute>
              </Layout>
            }
          />

          <Route
            path="/user-profile"
            element={
              <Layout>
                <ProtectedRoute permission={permissions?.VIEW_USER_MANAGEMENT}>
                  <UserProfile />
                </ProtectedRoute>
              </Layout>
            }
          />

          <Route
            path="/customer"
            element={
              <Layout>
                <ProtectedRoute
                  permission={permissions?.VIEW_CUSTOMER_MANAGEMENT}
                >
                  <CustomerManagement />
                </ProtectedRoute>
              </Layout>
            }
          />

          <Route
            path="/group-profile"
            element={
              <Layout>
                <ProtectedRoute
                  permission={permissions?.VIEW_CUSTOMER_MANAGEMENT}
                >
                  <GroupProfile />
                </ProtectedRoute>
              </Layout>
            }
          />

          <Route
            path="/metric-bm"
            element={
              <Layout>
                <ProtectedRoute
                  permission={permissions?.VIEW_METRIC_BLUEPRINT_MANAGEMENT}
                >
                  <MetricBlueprint />
                </ProtectedRoute>
              </Layout>
            }
          />

          <Route
            path="/"
            element={
              <Layout>
                <ProtectedRoute permission="bypass">
                  <Dashboard />
                </ProtectedRoute>
              </Layout>
            }
          />

          <Route
            path="/huddle"
            element={
              <Layout>
                <ProtectedRoute permission={permissions?.VIEW_HUDDLE}>
                  <Huddle />
                </ProtectedRoute>
              </Layout>
            }
          />

          <Route
            path="/pronto-ai"
            element={
              <Layout>
                <ProtectedRoute permission={permissions?.VIEW_PRONTO_AI}>
                  <ProntoAi />
                </ProtectedRoute>
              </Layout>
            }
          />

          <Route
            path="/opportunity-dashboard"
            element={
              <Layout>
                <ProtectedRoute
                  permission={permissions?.VIEW_OPPORTUNITY_DASHBOARD}
                >
                  <OpportunityDashboard />
                </ProtectedRoute>
              </Layout>
            }
          />

          <Route
            path="/metric-g"
            element={
              <Layout>
                <ProtectedRoute permission={permissions?.VIEW_GOALS}>
                  <MetricGoal />
                </ProtectedRoute>
              </Layout>
            }
          />

          <Route
            path="/metric-o"
            element={
              <Layout>
                <ProtectedRoute permission={permissions?.VIEW_METRICS}>
                  <MetricOpportunity />
                </ProtectedRoute>
              </Layout>
            }
          />

          <Route
            path="/providers"
            element={
              <Layout>
                <ProtectedRoute permission={permissions?.VIEW_PROVIDERS}>
                  <Providers />
                </ProtectedRoute>
              </Layout>
            }
          />

          <Route
            path="/doctor-compensation"
            element={
              <Layout>
                <ProtectedRoute
                  permission={permissions?.VIEW_DOCTOR_COMPENSATION}
                >
                  <DoctorCompensation />
                </ProtectedRoute>
              </Layout>
            }
          />

          <Route
            path="/p-and-l-reporting"
            element={
              <Layout>
                <ProtectedRoute permission={permissions?.VIEW_PNL_REPORT}>
                  <PnlReporting />
                </ProtectedRoute>
              </Layout>
            }
          />

          <Route
            path="/p-and-l-budget"
            element={
              <Layout>
                <ProtectedRoute permission={permissions?.VIEW_PNL_BUDGET}>
                  <PNLBudget />
                </ProtectedRoute>
              </Layout>
            }
          />

          <Route
            path="/resource-budget"
            element={
              <Layout>
                <ProtectedRoute permission={permissions?.VIEW_RESOURCE_BUDGET}>
                  <ResourceBudget />
                </ProtectedRoute>
              </Layout>
            }
          />

          <Route
            path="/my-profile"
            element={
              <Layout>
                <ProtectedRoute permission="bypass">
                  <MyProfile />
                </ProtectedRoute>
              </Layout>
            }
          />

          <Route
            path="/changePassword"
            element={<AuthPage page="changePassword" />}
          />

          {/*unAuthorized Routes */}

          <Route path="/auth" element={<AuthPage page="login" />} />
          <Route
            path="/createPassword"
            element={<AuthPage page="createPassword" />}
          />
          <Route
            path="/verifyEmail"
            element={<AuthPage page="verifyEmail" />}
          />
          <Route
            path="/forgotPassword"
            element={<AuthPage page="forgotPassword" />}
          />
          <Route
            path="/verifyResetPassword"
            element={<AuthPage page="verifyResetPassword" />}
          />
          <Route
            path="/resetPassword"
            element={<AuthPage page="resetPassword" />}
          />

          {/* Fallback Route */}

          <Route
            path="*"
            element={
              <Layout>
                <ProtectedRoute permission="bypass">
                  <Dashboard />
                </ProtectedRoute>
              </Layout>
            }
          />
        </Routes>
      </Router>

      <ToastContainer
        position="bottom-left"
        hideProgressBar={true}
        autoClose={2000}
      />
    </ThemeProvider>
  )
}

export default AppRoutes
